// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Sentry = require("../../Sentry.bs.js");
let Stdlib = require("@rescript/runtime/lib/js/Stdlib.js");
let RelayEnv = require("../../../RelayEnv.bs.js");
let DateFnsTz = require("../DateFns/DateFnsTz.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let LoginListener = require("./LoginListener.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AuthSessionRelay = require("../../../utils/AuthSessionRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelayReact = require("rescript-relay/src/RescriptRelayReact.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UserSessionQuery_graphql = require("../../../__generated__/UserSessionQuery_graphql.bs.js");
let UserSessionDataQuery_graphql = require("../../../__generated__/UserSessionDataQuery_graphql.bs.js");
let UserSessionAgentInfoQuery_graphql = require("../../../__generated__/UserSessionAgentInfoQuery_graphql.bs.js");
let UserSessionAgentInfo_agent_graphql = require("../../../__generated__/UserSessionAgentInfo_agent_graphql.bs.js");
let UserSessionClientInfoQuery_graphql = require("../../../__generated__/UserSessionClientInfoQuery_graphql.bs.js");
let UserSessionChapterInfoQuery_graphql = require("../../../__generated__/UserSessionChapterInfoQuery_graphql.bs.js");
let UserSessionClientAgentQuery_graphql = require("../../../__generated__/UserSessionClientAgentQuery_graphql.bs.js");
let UserSessionPermissionsQuery_graphql = require("../../../__generated__/UserSessionPermissionsQuery_graphql.bs.js");
let UserSessionClientAgent_agent_graphql = require("../../../__generated__/UserSessionClientAgent_agent_graphql.bs.js");
let UserSessionPlanFeaturesQuery_graphql = require("../../../__generated__/UserSessionPlanFeaturesQuery_graphql.bs.js");
let UserSessionPlansFeatures_plan_graphql = require("../../../__generated__/UserSessionPlansFeatures_plan_graphql.bs.js");
let UserSessionChapterTimezoneQuery_graphql = require("../../../__generated__/UserSessionChapterTimezoneQuery_graphql.bs.js");
let UserSessionUserDisplayInfoQuery_graphql = require("../../../__generated__/UserSessionUserDisplayInfoQuery_graphql.bs.js");
let UserSessionClientInfo_clientInfo_graphql = require("../../../__generated__/UserSessionClientInfo_clientInfo_graphql.bs.js");
let UserSessionChapterInfo_chapterInfo_graphql = require("../../../__generated__/UserSessionChapterInfo_chapterInfo_graphql.bs.js");
let UserSessionChapterPreferencesQuery_graphql = require("../../../__generated__/UserSessionChapterPreferencesQuery_graphql.bs.js");
let UserSessionPermissions_permissions_graphql = require("../../../__generated__/UserSessionPermissions_permissions_graphql.bs.js");
let UserSessionPlanFeatures_planFeatures_graphql = require("../../../__generated__/UserSessionPlanFeatures_planFeatures_graphql.bs.js");
let UserSessionChapterTimezone_chapterTimezone_graphql = require("../../../__generated__/UserSessionChapterTimezone_chapterTimezone_graphql.bs.js");
let UserSessionUserDisplayInfo_userDisplayInfo_graphql = require("../../../__generated__/UserSessionUserDisplayInfo_userDisplayInfo_graphql.bs.js");
let UserSessionChapterPreferences_chapterPreferences_graphql = require("../../../__generated__/UserSessionChapterPreferences_chapterPreferences_graphql.bs.js");

let convertVariables = UserSessionDataQuery_graphql.Internal.convertVariables;

let convertResponse = UserSessionDataQuery_graphql.Internal.convertResponse;

RescriptRelay_Query.useQuery(convertVariables, UserSessionDataQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UserSessionDataQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UserSessionDataQuery_graphql.node, convertResponse, prim => prim);

RescriptRelay_Query.fetch_(UserSessionDataQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UserSessionDataQuery_graphql.node, convertResponse, convertVariables);

RescriptRelay_Query.retain(UserSessionDataQuery_graphql.node, convertVariables);

let authenticatedStateContext = React.createContext(undefined);

function useForceAuthenticatedState(authType, fnName) {
  let authenticatedState = React.useContext(authenticatedStateContext);
  if (authenticatedState !== authType) {
    return Stdlib.panic("Calling " + fnName + " can only be done in code that is wrapped in `requireAuthenticatedAgent`. Make sure the page is wrapped in that.");
  }
}

let make = authenticatedStateContext.Provider;

let AuthenticatedStateProvider = {
  make: make
};

function useData(queryRef) {
  let authSession = AuthSession.use();
  let authSessionType;
  if (authSession !== undefined) {
    switch (authSession.__typename) {
      case "AuthSession" :
        authSessionType = authSession.user.role === "AGENT" ? "Agent" : "Client";
        break;
      case "AuthSessionUnauthenticated" :
        authSessionType = "Unauthenticated";
        break;
      case "AuthSessionInitializing" :
      case "__unselected" :
        authSessionType = "Other";
        break;
    }
  } else {
    authSessionType = "Other";
  }
  let data = usePreloaded(queryRef);
  return React.useMemo(() => {
    let match = data.sessionV5;
    if (authSessionType === "Unauthenticated") {
      return {
        TAG: "Ok",
        _0: "Unauthenticated"
      };
    }
    if (authSessionType === "Agent") {
      if (match === undefined) {
        return {
          TAG: "Error",
          _0: "Error decoding session"
        };
      }
      let match$1 = match.authenticatedUserV2;
      if (match$1.ok !== true) {
        return {
          TAG: "Error",
          _0: "Error decoding session"
        };
      }
      if (match$1.value !== undefined) {
        return {
          TAG: "Ok",
          _0: "Agent"
        };
      }
    } else if (authSessionType === "Client") {
      if (match === undefined) {
        return {
          TAG: "Error",
          _0: "Error decoding session"
        };
      }
      let match$2 = match.authenticatedUserV2;
      if (match$2.ok !== true) {
        return {
          TAG: "Error",
          _0: "Error decoding session"
        };
      }
      if (match$2.value !== undefined) {
        return {
          TAG: "Ok",
          _0: "Client"
        };
      }
    }
    if (match === undefined) {
      return {
        TAG: "Error",
        _0: "Error decoding session"
      };
    }
    let match$3 = match.authenticatedUserV2;
    if (match$3.ok === true && match$3.value === undefined) {
      return {
        TAG: "Ok",
        _0: "Unauthenticated"
      };
    } else {
      return {
        TAG: "Error",
        _0: "Error decoding session"
      };
    }
  }, [
    data,
    authSessionType
  ]);
}

let context = React.createContext("NotCalled");

let make$1 = context.Provider;

let convertVariables$1 = UserSessionQuery_graphql.Internal.convertVariables;

let convertResponse$1 = UserSessionQuery_graphql.Internal.convertResponse;

let use = RescriptRelay_Query.useQuery(convertVariables$1, UserSessionQuery_graphql.node, convertResponse$1);

RescriptRelay_Query.useLoader(convertVariables$1, UserSessionQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionQuery_graphql.node, convertResponse$1, prim => prim);

RescriptRelay_Query.fetch_(UserSessionQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.fetchPromised(UserSessionQuery_graphql.node, convertResponse$1, convertVariables$1);

RescriptRelay_Query.retain(UserSessionQuery_graphql.node, convertVariables$1);

function UserSession$Provider$RelaySyncComponent(props) {
  let setValue = props.setValue;
  let data = useData(props.queryRef);
  let match = use(undefined, "store-only", undefined, undefined);
  let currentAuthSession = match.currentAuthSession;
  React.useEffect(() => {
    let exit = 0;
    let exit$1 = 0;
    if (currentAuthSession !== undefined && currentAuthSession.__typename === "AuthSessionUnauthenticated") {
      exit = 1;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      if (data.TAG === "Ok") {
        switch (data._0) {
          case "Unauthenticated" :
            exit = 1;
            break;
          case "Agent" :
            setValue(param => "Agent");
            break;
          case "Client" :
            setValue(param => "Client");
            break;
        }
      } else {
        setValue(param => "Error");
      }
    }
    if (exit === 1) {
      setValue(param => "Unauthenticated");
    }
  }, [
    data,
    currentAuthSession
  ]);
  return null;
}

function UserSession$Provider$ComponentRelay(props) {
  let match = React.useState(() => "NotCalled");
  let setValue = match[1];
  let match$1 = useLoader();
  let loadQuery = match$1[1];
  let queryRef = match$1[0];
  let sessionData = use(undefined, "store-only", undefined, undefined);
  React.useEffect(() => LoginListener.addListener(() => setValue(param => "Loading")), []);
  React.useEffect(() => {
    let match = sessionData.currentAuthSession;
    if (match !== undefined) {
      switch (match.__typename) {
        case "AuthSession" :
          Sentry.addBreadcrumb("Refetching user context", "info", "auth");
          if (queryRef !== undefined) {
            fetchPromised(RelayEnv.environment, undefined, undefined, "network-only");
          } else {
            setValue(param => "Loading");
            loadQuery(undefined, "network-only", undefined);
          }
          break;
        case "AuthSessionInitializing" :
          setValue(param => "Loading");
          break;
        case "AuthSessionUnauthenticated" :
          setValue(param => "Unauthenticated");
          break;
        case "__unselected" :
          break;
      }
    }
  }, [sessionData]);
  return JsxRuntime.jsxs(make$1, {
    value: match[0],
    children: [
      JsxRuntime.jsx(React.Suspense, {
        children: queryRef !== undefined ? JsxRuntime.jsx(UserSession$Provider$RelaySyncComponent, {
            setValue: setValue,
            queryRef: Primitive_option.valFromOption(queryRef)
          }) : null,
        fallback: null
      }),
      props.children
    ]
  });
}

function UserSession$Provider$WithRelay(props) {
  return JsxRuntime.jsx(RescriptRelayReact.Context.Provider.make, {
    environment: RelayEnv.environment,
    children: JsxRuntime.jsx(UserSession$Provider$ComponentRelay, {
      children: props.children
    })
  });
}

let WithRelay = {
  dummy: AuthSessionRelay.dummy,
  make: UserSession$Provider$WithRelay
};

function useInitState() {
  return React.useContext(context);
}

let convertFragment = UserSessionChapterPreferences_chapterPreferences_graphql.Internal.convertFragment;

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionChapterPreferences_chapterPreferences_graphql.node, convertFragment);
}

let convertVariables$2 = UserSessionChapterPreferencesQuery_graphql.Internal.convertVariables;

let convertResponse$2 = UserSessionChapterPreferencesQuery_graphql.Internal.convertResponse;

let use$1 = RescriptRelay_Query.useQuery(convertVariables$2, UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2);

RescriptRelay_Query.useLoader(convertVariables$2, UserSessionChapterPreferencesQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, prim => prim);

RescriptRelay_Query.fetch_(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, convertVariables$2);

RescriptRelay_Query.fetchPromised(UserSessionChapterPreferencesQuery_graphql.node, convertResponse$2, convertVariables$2);

RescriptRelay_Query.retain(UserSessionChapterPreferencesQuery_graphql.node, convertVariables$2);

function defaultToOff(opt) {
  if (opt === "ON") {
    return "ON";
  } else {
    return "OFF";
  }
}

function useChapterPreference(preference) {
  useForceAuthenticatedState("Agent", "useChapterPreference");
  let data = use$1(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt(tmp);
  let preferences;
  if (agent !== undefined && agent.ok === true) {
    let preferences$1 = agent.value.defaultChapter.preferences;
    preferences = preferences$1 !== undefined ? preferences$1 : undefined;
  } else {
    preferences = undefined;
  }
  if (preferences === undefined) {
    return "OFF";
  }
  switch (preference) {
    case "AnonymousMatching" :
      return defaultToOff(preferences.anonymousMatching);
    case "AnonymousBroadcastProperties" :
      return defaultToOff(preferences.anonymousBroadcastProperties);
    case "DefaultToChapterPreferenceAreas" :
      return defaultToOff(preferences.defaultToChapterPreferenceAreas);
    case "GranularNotificationSettings" :
      return defaultToOff(preferences.granularNotificationSettings);
    case "HideChapterStats" :
      return defaultToOff(preferences.hideChapterStats);
    case "ImprovedLocations" :
      return defaultToOff(preferences.improvedLocations);
    case "MlsComingSoon" :
      return defaultToOff(preferences.mlsComingSoon);
    case "PayingChapter" :
      return defaultToOff(preferences.payingChapter);
    case "CheckPropertyStatusOnMLS" :
      return defaultToOff(preferences.mlsPropertyStatusCheck);
  }
}

let convertFragment$1 = UserSessionChapterTimezone_chapterTimezone_graphql.Internal.convertFragment;

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionChapterTimezone_chapterTimezone_graphql.node, convertFragment$1);
}

let convertVariables$3 = UserSessionChapterTimezoneQuery_graphql.Internal.convertVariables;

let convertResponse$3 = UserSessionChapterTimezoneQuery_graphql.Internal.convertResponse;

let use$2 = RescriptRelay_Query.useQuery(convertVariables$3, UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3);

RescriptRelay_Query.useLoader(convertVariables$3, UserSessionChapterTimezoneQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, prim => prim);

RescriptRelay_Query.fetch_(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, convertVariables$3);

RescriptRelay_Query.fetchPromised(UserSessionChapterTimezoneQuery_graphql.node, convertResponse$3, convertVariables$3);

RescriptRelay_Query.retain(UserSessionChapterTimezoneQuery_graphql.node, convertVariables$3);

function useChapterTimezone() {
  useForceAuthenticatedState("Agent", "useChapterTimezone");
  let data = use$2(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$1(tmp);
  if (agent === undefined) {
    return Stdlib.panic("No agent.");
  }
  if (agent.ok !== true) {
    return Stdlib.panic("No agent.");
  }
  let timezone = agent.value.defaultChapter.timezone;
  if (timezone !== undefined) {
    return DateFnsTz.Timezone.make(timezone);
  } else {
    return Stdlib.panic("No agent.");
  }
}

let convertFragment$2 = UserSessionChapterInfo_chapterInfo_graphql.Internal.convertFragment;

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionChapterInfo_chapterInfo_graphql.node, convertFragment$2);
}

let convertVariables$4 = UserSessionChapterInfoQuery_graphql.Internal.convertVariables;

let convertResponse$4 = UserSessionChapterInfoQuery_graphql.Internal.convertResponse;

let use$3 = RescriptRelay_Query.useQuery(convertVariables$4, UserSessionChapterInfoQuery_graphql.node, convertResponse$4);

RescriptRelay_Query.useLoader(convertVariables$4, UserSessionChapterInfoQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, prim => prim);

RescriptRelay_Query.fetch_(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, convertVariables$4);

RescriptRelay_Query.fetchPromised(UserSessionChapterInfoQuery_graphql.node, convertResponse$4, convertVariables$4);

RescriptRelay_Query.retain(UserSessionChapterInfoQuery_graphql.node, convertVariables$4);

let Chapter = {};

function useChapterInfoOpt() {
  let data = use$3(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$2(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value.defaultChapter;
  }
}

function useChapterInfo() {
  useForceAuthenticatedState("Agent", "useChapterInfo");
  return Stdlib_Option.getOrThrow(useChapterInfoOpt(), "Not an agent.");
}

let convertFragment$3 = UserSessionAgentInfo_agent_graphql.Internal.convertFragment;

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionAgentInfo_agent_graphql.node, convertFragment$3);
}

let convertVariables$5 = UserSessionAgentInfoQuery_graphql.Internal.convertVariables;

let convertResponse$5 = UserSessionAgentInfoQuery_graphql.Internal.convertResponse;

let use$4 = RescriptRelay_Query.useQuery(convertVariables$5, UserSessionAgentInfoQuery_graphql.node, convertResponse$5);

RescriptRelay_Query.useLoader(convertVariables$5, UserSessionAgentInfoQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, prim => prim);

RescriptRelay_Query.fetch_(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, convertVariables$5);

RescriptRelay_Query.fetchPromised(UserSessionAgentInfoQuery_graphql.node, convertResponse$5, convertVariables$5);

RescriptRelay_Query.retain(UserSessionAgentInfoQuery_graphql.node, convertVariables$5);

function avatarUrl(v, width, height) {
  return AvatarSrcUrl.from_key(width, height, Stdlib_Option.map(v.profilePhoto, a => a.key));
}

function name(v) {
  return v.firstName + ` ` + v.lastName;
}

let Agent = {
  avatarUrl: avatarUrl,
  name: name
};

function useAgentInfoOpt() {
  let data = use$4(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$3(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value;
  }
}

function useAgentInfo() {
  useForceAuthenticatedState("Agent", "useAgentInfo");
  let agentInfo = useAgentInfoOpt();
  return Stdlib_Option.getOrThrow(agentInfo, "Not an agent.");
}

let convertFragment$4 = UserSessionClientInfo_clientInfo_graphql.Internal.convertFragment;

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionClientInfo_clientInfo_graphql.node, convertFragment$4);
}

let convertVariables$6 = UserSessionClientInfoQuery_graphql.Internal.convertVariables;

let convertResponse$6 = UserSessionClientInfoQuery_graphql.Internal.convertResponse;

let use$5 = RescriptRelay_Query.useQuery(convertVariables$6, UserSessionClientInfoQuery_graphql.node, convertResponse$6);

RescriptRelay_Query.useLoader(convertVariables$6, UserSessionClientInfoQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionClientInfoQuery_graphql.node, convertResponse$6, prim => prim);

RescriptRelay_Query.fetch_(UserSessionClientInfoQuery_graphql.node, convertResponse$6, convertVariables$6);

RescriptRelay_Query.fetchPromised(UserSessionClientInfoQuery_graphql.node, convertResponse$6, convertVariables$6);

RescriptRelay_Query.retain(UserSessionClientInfoQuery_graphql.node, convertVariables$6);

let Agent$1 = {};

let Client = {
  Agent: Agent$1
};

function useClientInfoOpt() {
  let data = use$5(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "RegisteredClient" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let client = useOpt$4(tmp);
  if (client !== undefined && client.ok === true) {
    return client.value;
  }
}

function useClientInfo() {
  useForceAuthenticatedState("Client", "useClientInfo");
  return Stdlib_Option.getOrThrow(useClientInfoOpt(), "Not a client.");
}

let convertFragment$5 = UserSessionUserDisplayInfo_userDisplayInfo_graphql.Internal.convertFragment;

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionUserDisplayInfo_userDisplayInfo_graphql.node, convertFragment$5);
}

let convertVariables$7 = UserSessionUserDisplayInfoQuery_graphql.Internal.convertVariables;

let convertResponse$7 = UserSessionUserDisplayInfoQuery_graphql.Internal.convertResponse;

let use$6 = RescriptRelay_Query.useQuery(convertVariables$7, UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7);

RescriptRelay_Query.useLoader(convertVariables$7, UserSessionUserDisplayInfoQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, prim => prim);

RescriptRelay_Query.fetch_(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, convertVariables$7);

RescriptRelay_Query.fetchPromised(UserSessionUserDisplayInfoQuery_graphql.node, convertResponse$7, convertVariables$7);

RescriptRelay_Query.retain(UserSessionUserDisplayInfoQuery_graphql.node, convertVariables$7);

function useCurrentUserInfo() {
  let data = use$6(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined ? Primitive_option.some(match$2.userDisplayInfo) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let userInfo = useOpt$5(tmp);
  if (userInfo !== undefined && userInfo.ok === true) {
    return userInfo.value.data;
  }
}

let convertFragment$6 = UserSessionClientAgent_agent_graphql.Internal.convertFragment;

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionClientAgent_agent_graphql.node, convertFragment$6);
}

let convertVariables$8 = UserSessionClientAgentQuery_graphql.Internal.convertVariables;

let convertResponse$8 = UserSessionClientAgentQuery_graphql.Internal.convertResponse;

let use$7 = RescriptRelay_Query.useQuery(convertVariables$8, UserSessionClientAgentQuery_graphql.node, convertResponse$8);

RescriptRelay_Query.useLoader(convertVariables$8, UserSessionClientAgentQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionClientAgentQuery_graphql.node, convertResponse$8, prim => prim);

RescriptRelay_Query.fetch_(UserSessionClientAgentQuery_graphql.node, convertResponse$8, convertVariables$8);

RescriptRelay_Query.fetchPromised(UserSessionClientAgentQuery_graphql.node, convertResponse$8, convertVariables$8);

RescriptRelay_Query.retain(UserSessionClientAgentQuery_graphql.node, convertVariables$8);

function useClientAgentOpt() {
  let data = use$7(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "RegisteredClient" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let client = useOpt$6(tmp);
  if (client !== undefined && client.ok === true) {
    return client.value.agent;
  }
}

function useClientAgent() {
  useForceAuthenticatedState("Client", "useClientAgent");
  return Stdlib_Option.getOrThrow(useClientAgentOpt(), "Not a client.");
}

let convertFragment$7 = UserSessionPlansFeatures_plan_graphql.Internal.convertFragment;

function useOpt$7(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionPlansFeatures_plan_graphql.node, convertFragment$7);
}

let convertFragment$8 = UserSessionPlanFeatures_planFeatures_graphql.Internal.convertFragment;

function useOpt$8(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionPlanFeatures_planFeatures_graphql.node, convertFragment$8);
}

let convertVariables$9 = UserSessionPlanFeaturesQuery_graphql.Internal.convertVariables;

let convertResponse$9 = UserSessionPlanFeaturesQuery_graphql.Internal.convertResponse;

let use$8 = RescriptRelay_Query.useQuery(convertVariables$9, UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9);

RescriptRelay_Query.useLoader(convertVariables$9, UserSessionPlanFeaturesQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, prim => prim);

RescriptRelay_Query.fetch_(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, convertVariables$9);

RescriptRelay_Query.fetchPromised(UserSessionPlanFeaturesQuery_graphql.node, convertResponse$9, convertVariables$9);

RescriptRelay_Query.retain(UserSessionPlanFeaturesQuery_graphql.node, convertVariables$9);

function isFree(x) {
  let tmp = x.type_;
  return tmp === "FREE";
}

function isTrial(x) {
  let tmp = x.handle;
  return tmp === "PRO_TRIAL";
}

let Plan = {
  isFree: isFree,
  isTrial: isTrial
};

function usePlan() {
  useForceAuthenticatedState("Agent", "usePlan");
  let data = use$8(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$8(tmp);
  let tmp$1;
  tmp$1 = agent !== undefined && agent.ok === true ? Primitive_option.some(agent.value.membership.account.subscription_.plan.fragmentRefs) : undefined;
  let plan = useOpt$7(tmp$1);
  if (plan !== undefined && plan.ok === true) {
    return plan.value;
  } else {
    return Stdlib.panic("No plan found.");
  }
}

function useHasPlanFeature(feature) {
  useForceAuthenticatedState("Agent", "useHasPlanFeature");
  let data = use$8(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$8(tmp);
  let tmp$1;
  tmp$1 = agent !== undefined && agent.ok === true ? Primitive_option.some(agent.value.membership.account.subscription_.plan.fragmentRefs) : undefined;
  let plan = useOpt$7(tmp$1);
  if (plan !== undefined && plan.ok === true) {
    return plan.value.features.includes(feature);
  } else {
    return false;
  }
}

let convertFragment$9 = UserSessionPermissions_permissions_graphql.Internal.convertFragment;

function useOpt$9(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, UserSessionPermissions_permissions_graphql.node, convertFragment$9);
}

let convertVariables$10 = UserSessionPermissionsQuery_graphql.Internal.convertVariables;

let convertResponse$10 = UserSessionPermissionsQuery_graphql.Internal.convertResponse;

let use$9 = RescriptRelay_Query.useQuery(convertVariables$10, UserSessionPermissionsQuery_graphql.node, convertResponse$10);

RescriptRelay_Query.useLoader(convertVariables$10, UserSessionPermissionsQuery_graphql.node, prim => prim);

RescriptRelay_Query.usePreloaded(UserSessionPermissionsQuery_graphql.node, convertResponse$10, prim => prim);

RescriptRelay_Query.fetch_(UserSessionPermissionsQuery_graphql.node, convertResponse$10, convertVariables$10);

RescriptRelay_Query.fetchPromised(UserSessionPermissionsQuery_graphql.node, convertResponse$10, convertVariables$10);

RescriptRelay_Query.retain(UserSessionPermissionsQuery_graphql.node, convertVariables$10);

function useHasPermission(permission) {
  useForceAuthenticatedState("Agent", "useHasPermission");
  let data = use$9(undefined, "store-only", undefined, undefined);
  let match = data.sessionV5;
  let tmp;
  if (match !== undefined) {
    let match$1 = match.authenticatedUserV2;
    if (match$1.ok === true) {
      let match$2 = match$1.value;
      tmp = match$2 !== undefined && match$2.__typename === "Agent" ? Primitive_option.some(match$2.fragmentRefs) : undefined;
    } else {
      tmp = undefined;
    }
  } else {
    tmp = undefined;
  }
  let agent = useOpt$9(tmp);
  if (agent !== undefined && agent.ok === true) {
    return agent.value.permissions.includes(permission);
  } else {
    return false;
  }
}

function useShouldShowPropertyDetails(propertyAgentId) {
  useForceAuthenticatedState("Agent", "useShouldShowPropertyDetails");
  let agent = useAgentInfoOpt();
  let isPropertyDetailsEnabled = useHasPlanFeature("PROPERTY_DETAILS");
  let isCurrentUser = propertyAgentId !== undefined && agent !== undefined ? propertyAgentId === agent.id : false;
  if (isCurrentUser) {
    return true;
  } else {
    return isPropertyDetailsEnabled;
  }
}

let Provider = {
  WithRelay: WithRelay
};

let provider = UserSession$Provider$WithRelay;

exports.Provider = Provider;
exports.provider = provider;
exports.AuthenticatedStateProvider = AuthenticatedStateProvider;
exports.useInitState = useInitState;
exports.useShouldShowPropertyDetails = useShouldShowPropertyDetails;
exports.Chapter = Chapter;
exports.useChapterPreference = useChapterPreference;
exports.useChapterTimezone = useChapterTimezone;
exports.useChapterInfoOpt = useChapterInfoOpt;
exports.useChapterInfo = useChapterInfo;
exports.Agent = Agent;
exports.useAgentInfoOpt = useAgentInfoOpt;
exports.useAgentInfo = useAgentInfo;
exports.Client = Client;
exports.useClientInfoOpt = useClientInfoOpt;
exports.useClientInfo = useClientInfo;
exports.useClientAgent = useClientAgent;
exports.useCurrentUserInfo = useCurrentUserInfo;
exports.Plan = Plan;
exports.usePlan = usePlan;
exports.useHasPlanFeature = useHasPlanFeature;
exports.useHasPermission = useHasPermission;
/*  Not a pure module */
